import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { ItemGeneralListado } from '../../helpers/components/itemClasses/itemListadoGeneral.class';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { SxHttpService } from './sxHttp.service';
import { Product } from '../model/interfaces/product.interface';
import { ProductSearch } from '../model/classes/productSearch.class';

const serviceUrl = "api/productConfiguration";

const contactos = [
  {
    id: 6,
    Nombre: 'Troy',
    Apellido: 'Mcclure',
    Puesto: 'Engineer ui/ux',
    Empresa: 'Inworx',
    Imagen: 'assets/img/contacts/troy-mcclure.png',
    Telefono: '+54 9 11 0000-0000',
    Email: 'noseolvidendetroy@gmail.com.ar'
  },
  {
    id: 5,
    Nombre: 'Esteban',
    Apellido: 'Wiedemann',
    Puesto: 'Engineer ui/ux',
    Empresa: 'Inworx',
    Imagen: 'assets/img/contacts/nico.jpg',
    Telefono: '+54 9 11 0000-0000',
    Email: 'wiedemann.en@gmail.com'
  },
  {
    id: 1,
    Nombre: 'Federico',
    Apellido: 'Rocha',
    Puesto: 'Engineer ui/ux',
    Empresa: 'Inworx',
    Imagen: 'assets/img/contacts/fede.jpg',
    Telefono: '+54 9 11 0000-0000',
    Email: 'federiconrocha@gmail.com.ar'
  },
  {
    id: 2,
    Nombre: 'Homer Jay',
    Apellido: 'Simpson',
    Puesto: 'Engineer ui/ux',
    Empresa: 'Inworx',
    Imagen: 'assets/img/contacts/homero.jpg',
    Telefono: '+54 9 11 0000-0000',
    Email: 'soyhomero@gmail.com.ar'
  },
  {
    id: 3,
    Nombre: 'Leandro',
    Apellido: 'Se los Santos',
    Puesto: 'Engineer ui/ux',
    Empresa: 'Inworx',
    Imagen: 'assets/img/contacts/lean.jpg',
    Telefono: '+54 9 11 0000-0000',
    Email: 'Leandro.delossantos@smart-ix.com'
  },
  {
    id: 4,
    Nombre: 'Marcelo',
    Apellido: 'Sosa',
    Puesto: 'Engineer ui/ux',
    Empresa: 'Inworx',
    Imagen: 'assets/img/contacts/marcelo.png',
    Telefono: '+54 9 11 0000-0000',
    Email: 'marcelo.sosa@smart-ix.com'
  },
  {
    id: 5,
    Nombre: 'Esteban',
    Apellido: 'Wiedemann',
    Puesto: 'Engineer ui/ux',
    Empresa: 'Inworx',
    Imagen: 'assets/img/contacts/nico.jpg',
    Telefono: '+54 9 11 0000-0000',
    Email: 'wiedemann.en@gmail.com'
  },
  {
    id: 6,
    Nombre: 'Troy',
    Apellido: 'Mcclure',
    Puesto: 'Engineer ui/ux',
    Empresa: 'Inworx',
    Imagen: 'assets/img/contacts/troy-mcclure.png',
    Telefono: '+54 9 11 0000-0000',
    Email: 'noseolvidendetroy@gmail.com.ar'
  },
  {
    id: 0,
    Nombre: 'Elvio',
    Apellido: 'Velasquez',
    Puesto: 'Engineer ui/ux',
    Empresa: 'Inworx',
    Imagen: 'assets/img/contacts/default.png',
    Telefono: '+54 9 11 0000-0000',
    Email: 'elvio.velasquez@contractor.inworx.com'
  }
];

@Injectable()
export class ProductsService {
  constructor(private http: Http, private sxHttp: SxHttpService) { }

  private productosUrl = 'api/productos';

  getNewAvailablesProducts(
    codSubscription: string,
    codChannel: string
  ): Observable<ItemGeneralListado[]> {
    const parametros = new URLSearchParams();
    parametros.set('codSistema', codSubscription);
    parametros.set('codNegocio', codChannel);
    return this.http
      .get(this.productosUrl, { search: parametros })
      .map(response => response.json().data as ItemGeneralListado[]);
  }

  getAllProducts(): Observable<ProductSearch[]> {
    return this.http
      .get('api/productos2')
      .map(response => response.json().data as ProductSearch[]);
  }

  getProductsBySubscription(codOrganization: string, codSubscription: string, state: string = null): Observable<Product[]> {
    const search = {
      codOrganization,
      codSubscription,
      state,
    };

    if (state) {
      search['state'] = state;
    }
    
    return this.sxHttp
      .get('api/productConfiguration', search)
      .map(response => response.json().data as Product[]);
  }
  /**
     * get the products list from backend and map it
     * to a compatible format for the General Listing component
     */
  getForList(
    organizationcode:string,
    subscriptionCode: string,
    channelCode: string
  ): Observable<ItemGeneralListado[]> {
    return this.sxHttp
      .get('api/productConfiguration/'+organizationcode +'/'+ subscriptionCode + '/' + channelCode)
      .map(response => {
        return response.json().data.map(product => {
          return {
            id: product.codProduct,
            Titulo: product.descripcion,
            Descripcion: product.descripcionExt,
            Imagen: product.urlImage,
            contactos // Contactos Hardcodeados
          };
        }) as ItemGeneralListado[];
      });
  }

  getProducts(organizationCode: string, subscriptionCode : string, channelCode: string): Observable<Product[]> {
    return this.sxHttp
      .get('api/productConfiguration/'+ organizationCode + '/' + subscriptionCode + '/' + channelCode)
      .map(response => response.json().data as Product[]);
  }

  getDetailProduct(
    codOrganization,
    codSubscription,
    codChannel,
    codProduct
  ): Observable<Product> {
    return this.sxHttp
      .get(
        'api/productConfiguration' +
        '/' +
        codOrganization +
        '/' +
        codSubscription +
        '/' +
        codChannel +
        '/' +
        codProduct
      )
      .map(response => response.json().data as Product);
  }
  getDetailProductStatus(
    codOrganization,
    codSubscription,
    codChannel,
    codProduct,
    status
  ): Observable<Product> {
    return this.sxHttp
      .get(
        'api/productConfiguration' +
        '/' +
        codOrganization +
        '/' +
        codSubscription +
        '/' +
        codChannel +
        '/' +
        codProduct +
        '/' +
        status
      )
      .map(response => response.json().data as Product);
  }
  crear(product: Product): Promise<Product> {
    return this.sxHttp
      .post('api/productConfiguration', product)
      .toPromise()
      .then(response => response.json().data as Product);
  }

  /**
     * Edit an existing product to the backend
     */
  editar(codOrganization, codSubscription, codChannel, codProduct, product: Product): Promise<Product> {
    delete product['completitud'];
    return this.sxHttp
      .put(
        'api/productConfiguration/' +
         codOrganization + 
         '/' + 
         codSubscription + 
         '/' + 
         codChannel + 
         '/' + 
         codProduct,
         product
      )
      .toPromise()
      .then(response => response.json().data as Product);
  }

  /**
  * Delete existing product to the backend
  */
  deleteProduct(organizationCode: string, subscriptionCode: string, channelCode: string, productCode: string): Observable<any> {
    return this.sxHttp
      .delete(`api/productConfiguration/` +
      organizationCode + '/' +
      subscriptionCode + '/' +
      channelCode + '/' +
      productCode)
      .map(result => result.json().data);
  }

  /**
  * Active an existing product to the backend
  */
  activar(organizationCode: string, subscriptionCode: string, channelCode: string, productCode: string): Promise<Product> {
    const url = `api/productConfiguration/` +
    organizationCode + '/' +
    subscriptionCode + '/' +
    channelCode + '/' +
    productCode +
    `/activar`;
    return this.sxHttp
      .put(url, null)
      .toPromise()
      .then(response => response.json().data as Product);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/products.service.ts